/*
 * File: UILinkListItem.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Anderson on 06/03/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description:
 */

import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { ListItem, ListItemText } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import PropTypes from "prop-types";

const styles = theme => ({
  listItem: {
    position: "relative",
    paddingLeft: 0,
    paddingTop: theme.spacing(2.5),
    paddingBottom: theme.spacing(2.5),
    borderBottom: `1px solid ${theme.palette.common.border}`
  }
});

const UILinkListItem = ({ classes, includeArrow, link }) => {
  return (
    <React.Fragment>
      <ListItem className={classes.listItem}>
        <ListItemText
          primary={link.primaryString}
          secondary={link.secondaryString}
        />
        {includeArrow && link.url && <ArrowRightIcon />}
      </ListItem>
      <Divider />
    </React.Fragment>
  );
};

UILinkListItem.propTypes = {
  classes: PropTypes.object.isRequired,
  includeArrow: PropTypes.bool,
  link: PropTypes.object.isRequired
};

export default withStyles(styles)(UILinkListItem);
